import React from 'react';
import styled from '@emotion/styled';
import { Spacer } from 'views/components/atoms/Spacer';
import { AppLinkList } from 'views/components/organisms/AppLinkList';
import { Driver } from 'views/components/atoms/Driver';
import { AvailableApplication } from 'models/Device/type';
import { AppSearchForm } from 'views/components/organisms/AppSearchForm';

const Wrapper = styled.div`
  text-align: initial;
  padding-bottom: 28px;
`;

type AppSearchLayoutProps = {
  applications: AvailableApplication[];
  onSearchInputChange(input: string): void;
  searchFormPlaceholder: string;
};

export const AppSearchPageLayout: React.FC<AppSearchLayoutProps> = ({
  applications,
  onSearchInputChange,
  searchFormPlaceholder,
}) => (
  <Wrapper>
    <Spacer />
    <AppSearchForm
      onSearchInputChange={onSearchInputChange}
      placeholder={searchFormPlaceholder}
    />
    <Spacer />
    <Driver />

    <AppLinkList applications={applications} distributions={[]} />
    <Driver />
    <Spacer />
  </Wrapper>
);
